// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Procedure view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...ProcedureRender }`, [ProcedureRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const ProcedureRenderFragment = graphql(`
  fragment ProcedureRender on Procedure @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    instantiatesCanonical
    instantiatesUri
    basedOn {
      reference
      type
      display
    }
    partOf {
      reference
      type
      display
    }
    status
    statusReason {
      text
      coding {
        system
        code
        display
      }
    }
    category {
      text
      coding {
        system
        code
        display
      }
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    performedDateTime
    performedPeriod {
      start
      end
    }
    performedString
    performedAge {
      value
      comparator
      unit
      system
      code
    }
    performedRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
    }
    recorder {
      reference
      type
      display
    }
    asserter {
      reference
      type
      display
    }
    performer {
      function {
        text
        coding {
          system
          code
          display
        }
      }
      actor {
        reference
        type
        display
      }
      onBehalfOf {
        reference
        type
        display
      }
    }
    location {
      reference
      type
      display
    }
    reasonCode {
      text
      coding {
        system
        code
        display
      }
    }
    reasonReference {
      reference
      type
      display
    }
    bodySite {
      text
      coding {
        system
        code
        display
      }
    }
    outcome {
      text
      coding {
        system
        code
        display
      }
    }
    report {
      reference
      type
      display
    }
    complication {
      text
      coding {
        system
        code
        display
      }
    }
    complicationDetail {
      reference
      type
      display
    }
    followUp {
      text
      coding {
        system
        code
        display
      }
    }
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
    focalDevice {
      action {
        text
        coding {
          system
          code
          display
        }
      }
      manipulated {
        reference
        type
        display
      }
    }
    usedReference {
      reference
      type
      display
    }
    usedCode {
      text
      coding {
        system
        code
        display
      }
    }
  }
`);
